import React from 'react';
import PropTypes from 'prop-types';

const AutoSkipPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M23.997 12.003V7.98c0-.551.448-.98 1-.98.313 0 .607.127.796.375l6.003 8.023a1 1 0 0 1 0 1.21l-6.003 8.022c-.334.44-.962.485-1.401.15-.249-.188-.395-.442-.395-.755v-4.022h-5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h5zM8 12.003V7.98C8 7.429 8.447 7 9 7c.313 0 .607.127.796.375l6.003 8.023a1 1 0 0 1 0 1.21L9.795 24.63c-.334.44-.962.485-1.4.15-.25-.188-.396-.442-.396-.755v-4.022H3a1 1 0 0 1-.999-1v-6a1 1 0 0 1 1-1h5z"
    />
  );
};

AutoSkipPath.propTypes = {
  fill: PropTypes.string,
};

export default AutoSkipPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/auto-skip.jsx